import { z } from "zod";
import { COACHING_MODEL_OPTIONS } from "./playbookCoachingModel.js";
const splitCoachingModelIdSchema = z.enum([
  "opus-4-8-high",
  "opus-4-6-high",
  "gpt-5-6-sol-high",
  "gpt-5-6-sol-medium",
  "gpt-5-5-medium",
  "glm-5-3-flash-high"
]);
function asSplitCoachingModelId(id) {
  return splitCoachingModelIdSchema.parse(id);
}
const SPLIT_ONLY_MODEL_LABELS = {
  "gpt-5-6-sol-high": "GPT-5.6 Sol (high)",
  "glm-5-3-flash-high": "GLM-5.3 Flash (high)"
};
const SPLIT_COACHING_MODEL_OPTIONS = splitCoachingModelIdSchema.options.map((id) => ({
  id,
  label: COACHING_MODEL_OPTIONS.find((option) => option.id === id)?.label ?? SPLIT_ONLY_MODEL_LABELS[id] ?? id
}));
function getSplitCoachingModelLabel(id) {
  return SPLIT_COACHING_MODEL_OPTIONS.find((option) => option.id === id)?.label ?? id;
}
const DEFAULT_SPLIT_COACHING_FOCUS_MODEL_ID = "glm-5-3-flash-high";
const DEFAULT_SPLIT_COACHING_NOTE_MODEL_ID = "opus-4-6-high";
function checkSplitCoachingContent(content) {
  return "opportunities" in content && Array.isArray(content.opportunities);
}
function applyCoachingOpportunityNote(options) {
  const { content, criterionId, note } = options;
  if (!content.opportunities.some(
    (opportunity) => opportunity.criterion_id === criterionId
  )) {
    return void 0;
  }
  return {
    ...content,
    opportunities: content.opportunities.map(
      (opportunity) => opportunity.criterion_id === criterionId ? { ...opportunity, note } : opportunity
    )
  };
}
export {
  DEFAULT_SPLIT_COACHING_FOCUS_MODEL_ID,
  DEFAULT_SPLIT_COACHING_NOTE_MODEL_ID,
  SPLIT_COACHING_MODEL_OPTIONS,
  applyCoachingOpportunityNote,
  asSplitCoachingModelId,
  checkSplitCoachingContent,
  getSplitCoachingModelLabel,
  splitCoachingModelIdSchema
};
//# sourceMappingURL=splitCoachingPipeline.js.map
